import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { Authority } from "./components/landing/Authority";
import { Identification } from "./components/landing/Identification";
import { Manifesto } from "./components/landing/Manifesto";
import { Pillars } from "./components/landing/Pillars";
import { About } from "./components/landing/About";
import { Commitments } from "./components/landing/Commitments";
import { Faq } from "./components/landing/Faq";
import { FinalCta } from "./components/landing/FinalCta";
import { WhatsFloat } from "./components/landing/WhatsFloat";
import Stats from "./components/landing/Stats";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/estatisticas" element={<Stats />} />
      </Routes>
    </BrowserRouter>
  );
}

const Landing = () => (
  <div className="App bg-sand">
    <div className="grain-overlay" aria-hidden="true" />
    <Header />
    <main>
      <Hero />
      <Authority />
      <Identification />
      <Manifesto />
      <Pillars />
      <About />
      <Commitments />
      <Faq />
      <FinalCta />
    </main>
    <WhatsFloat />
  </div>
);

export default App;
